import { PAGE_TYPE } from '@sravni/ugc/lib/organizations/constants';

export type Winner = { id: string; nomination: string };

type Winners = Partial<Record<PAGE_TYPE, Winner[]>>;

export const winners: Winners = {
  [PAGE_TYPE.Zaimy]: [
    {
      id: '5e95c820380d2c001c873e36',
      nomination: 'МФО года',
    },
    {
      id: '634d6335c0eb6d00242282de',
      nomination: 'Технологичная МФО года',
    },
    {
      id: '652684657e041b0029c1cadd',
      nomination: 'Микрозайм года',
    },
  ],
  [PAGE_TYPE.Bank]: [
    {
      id: '5bb4f767245bc22a520a609b',
      nomination: 'Банк года',
    },
    {
      id: '5bb4f767245bc22a520a60ab',
      nomination: 'Вклад года',
    },
    {
      id: '5bb4f767245bc22a520a6111',
      nomination: 'Кредитная карта года',
    },
    {
      id: '5bb4f767245bc22a520a5fd5',
      nomination: 'Кредит года',
    },
    {
      id: '5bb4f769245bc22a520a62a5',
      nomination: 'Технологичный банк года',
    },
    {
      id: '5bb4f767245bc22a520a6081',
      nomination: 'Дебетовая карта года',
    },
    {
      id: '5bb4f767245bc22a520a60fb',
      nomination: 'Банк года для малого и среднего бизнеса',
    },
    {
      id: '5bb4f767245bc22a520a609b',
      nomination: 'Технологичный банк для малого и среднего бизнеса',
    },
  ],
  [PAGE_TYPE.StrakhovajaKompanija]: [
    {
      id: '147351',
      nomination: 'Страховая компания года',
    },
    {
      id: '7468',
      nomination: 'Технологичная страховая компания',
    },
    {
      id: '7659',
      nomination: 'ОСАГО года',
    },
    {
      id: '7469',
      nomination: 'Каско года',
    },
    {
      id: '8105',
      nomination: 'Страхование ипотеки года',
    },
    {
      id: '7809',
      nomination: 'Страхование путешественников года',
    },
  ],
  [PAGE_TYPE.Shkola]: [
    {
      id: '61767bb3ae56ab001d91f807',
      nomination: 'Онлайн-школа года',
    },
  ],
};
